class MetricManager {
  constructor(data) {
    this.data = data
    this.totalAmountSpent = data?.total_amount_spent ?? 0
    this.activeCustomerCount = data?.active_customers_count ?? 0
    this.averageTat = data?.average_tat ?? 0
    this.totalOrderCount = data?.total_orders ?? 0
    this.oneTimeUsers = data?.one_time_users ?? 0

    this.unique_users = data?.unique_users ?? 0
    this.repeat_users = data?.repeat_users ?? 0
    this.totalCompanyEmployeesCount = data?.total_company_employees_count ?? 0
    this.activeEmployeesAppointmentsCount = data?.active_employees_appointments_count ?? 0
    this.inactiveEmployeesAppointmentsCount = data?.inactive_employees_appointments_count ?? 0
    this.activeDependentsAppointmentsCount = data?.active_dependents_appointments_count ?? 0
    this.inactiveDependentsAppointmentsCount = data?.inactive_dependents_appointments_count ?? 0
    this.activeEmployeesUpcomingAppointmentsCount = data?.active_employees_upcoming_appointments_count ?? 0
    this.activeDependentsUpcomingAppointmentsCount = data?.active_dependents_upcoming_appointments_count ?? 0
    this.activeUniqueEmployeesAppointmentsCount = data?.active_unique_employees_appointments_count ?? 0
    this.inactiveUniqueEmployeesAppointmentsCount = data?.inactive_unique_employees_appointments_count ?? 0
    this.activeUniqueDependentsAppointmentsCount = data?.active_unique_dependents_appointments_count ?? 0
    this.inactiveUniqueDependentsAppointmentsCount = data?.inactive_unique_dependents_appointments_count ?? 0
    // this.totalHealthChecksCompleted = this.getTotalHealthChecksCompleted()
    // this.healthCheckAvailedPercentage = this.getHealthCheckAvailedPercentage()
    this.totalSplitCount = this.totalSplitCount()
    this.donutGraphData = this.donutGraphData()
    this.partners = this.partners()
    this.successMetric = data.success_metric

    this.activeSponsoredEmployeesCount = data?.active_customers_count ?? 0
    this.activeEmployeeUtilizationPercentage = this.floorPercentage(this.unique_users, this.activeSponsoredEmployeesCount)
    this.repeatSponsoredUserCount = data?.repeat_users ?? 0
    this.repeatSponsoredUserCountPercentage = this.floorPercentage(this.repeat_users, this.activeSponsoredEmployeesCount)

    this.barLabelsWallet = this.getMonthOrder(data?.month_on_month_transaction);
    this.bardataWallet = this.getBarData(data?.month_on_month_transaction)
    this.monthOnMonthMaxValue = this.getMonthOnMonthMaxValue(data.month_on_month_transaction)
    this.highestValueNotation = this.getHighestValueNotation(this.bardataWallet)
    this.barBgColorsWallet = this.getBarBgColors(this.bardataWallet)
  }

    // Function to get the bar data in the correct order
  getBarData(monthData) {
      const dynamicOrder = this.getMonthOrder(monthData);

      // Initialize an object with all months in the dynamic order set to 0
      let monthOnMonthTransaction = dynamicOrder.reduce((acc, month) => {
      acc[month] = 0;
      return acc;
    }, {});

    // Populate the object with the actual data
    if (monthData && typeof monthData === 'object') {
      for (let [month, value] of Object.entries(monthData)) {
        if (dynamicOrder.includes(month)) {
          monthOnMonthTransaction[month] = value;
        }
      }
    }
    // Return the values in the order of dynamicOrder
    return dynamicOrder.map(month => monthOnMonthTransaction[month]);
  }

  getMonthOrder(monthData) {
    if (monthData === null || monthData === undefined) return [];

    const dataMonths = Object.keys(monthData);
    return dataMonths;
  }

  getBarBgColors(bardata){
    // Generate bar background colors
    return bardata.map(() => '#2563EB');
  }

  getHighestValueNotation(arr){
    const maxValue = Math.max(...arr.map(Number))
    return this.getNumberNotation(maxValue)
  }

  getNumberNotation(value){
    if (value >= 10000000) {
      return 'Cr'; // Crores
    } else if (value >= 100000) {
      return 'L'; // Lakhs
    } else if (value >= 1000) {
      return 'K'; // Thousands
    }
    return '';
  }

  getUtilizatedPercentageAmount(num, total) {
    if (num === null || num === undefined) return '0';
    
    return   Math.round(total * (num/100))  
  }

  getTotalHealthChecksCompleted() {
    return (this.activeEmployeesAppointmentsCount + this.activeDependentsAppointmentsCount + this.inactiveEmployeesAppointmentsCount + this.inactiveDependentsAppointmentsCount)
  }

  getHealthCheckAvailedPercentage() {
    return this.activeCustomerCount ? Math.round((this.activeEmployeesAppointmentsCount / this.activeCustomerCount) * 100) : 0
  }

  floorPercentage(numerator, denominator) {
    return Math.round((numerator / denominator) * 100)
  }

  totalSplitCount() {
    let totalSplit = 0
    let splitData = this.data.split
    Object.keys(splitData).forEach((hashKey) => {
      totalSplit += splitData[hashKey]
    })

    return totalSplit
  }

  donutGraphData() {
    let result = []
    const { standard, express } = this.data.split

    result.push({
      text: 'Standard Delivery',
      number: standard || 0,
      percentage: standard ? this.floorPercentage(standard, this.totalSplitCount) : 0,
      color: standard ? '#2563EB' : '#E5E7EB',
    })
    result.push({
      text: 'Express Delivery',
      number: express || 0,
      percentage: express ? this.floorPercentage(express, this.totalSplitCount) : 0,
      color: express ? '#4FAD96' : '#E5E7EB',
    })

    return result
  }

  partners() {
    return this.data.providers.map((item, key) => ({
      partner_name: item[0],
      employee_count: item[1],
    }))
  }

  getMonthOnMonthMaxValue(monthOnMonthTransaction) {
    if (monthOnMonthTransaction === null || monthOnMonthTransaction === undefined) return 0;
    let maxValue = 0;
    for (let [month, value] of Object.entries(monthOnMonthTransaction)) {
      if (value > maxValue) maxValue = value;
    }
    return maxValue;
  }
}

export default MetricManager
